throw new Error(`electron 对主进程和渲染进程使用不同的代码: 
在electron主进程中, 你应该导入“@lynker-desktop/electron-window-manager/main” 
在electron渲染过程中, 你应该导入“@lynker-desktop/electron-window-manager/renderer”
`);

export {};